/* eslint-disable */
export const Colors = {
  baseBrand50: "#01263c",
  baseBrand100: "#013a5b",
  baseBrand200: "#074d78",
  baseBrand300: "#055485",
  baseBrand400: "#06649F",
  baseBrand500: "#078fe4",
  baseBrand600: "#429ed7",
  baseBrand700: "#53A8DD",
  baseBrand800: "#7ABDE7",
  baseBrand900: "#8DC8ED",
  baseSteel50: "#38393d",
  baseSteel100: "#313235",
  baseSteel200: "#494b50",
  baseSteel300: "#57585c",
  baseSteel400: "#95989d",
  baseSteel500: "#c9cbcf",
  baseSteel600: "#d1d3d6",
  baseSteel700: "#dfe0e2",
  baseSteel800: "#f7f8f9",
  baseSteel900: "#fff",
  baseGray50: "#070708",
  baseGray100: "#0E0E0F",
  baseGray200: "#2b2b2e",
  baseGray300: "#1B1C1E",
  baseGray400: "#2E2F33",
  baseGray500: "#36353b",
  baseGray600: "#414045",
  baseGray700: "#504f54",
  baseGray800: "#6F6E74",
  baseGray900: "#838288",
  baseBlue50: "#01263c",
  baseBlue100: "#013a5b",
  baseBlue200: "#074d78",
  baseBlue300: "#055485",
  baseBlue400: "#06649F",
  baseBlue500: "#078fe4",
  baseBlue600: "#3597d4",
  baseBlue700: "#53A8DD",
  baseBlue800: "#7ABDE7",
  baseBlue900: "#8DC8ED",
  baseGreen50: "#001f11",
  baseGreen100: "#003d24",
  baseGreen200: "#004d2d",
  baseGreen300: "#005330",
  baseGreen400: "#006E40",
  baseGreen500: "#00a35f",
  baseGreen600: "#1AA168",
  baseGreen700: "#33B981",
  baseGreen800: "#4DD099",
  baseGreen900: "#5ADCA5",
  baseRed50: "#240200",
  baseRed100: "#4d0600",
  baseRed200: "#65211b",
  baseRed300: "#882D25",
  baseRed400: "#AE3A30",
  baseRed500: "#dc4e41",
  baseRed600: "#da5145",
  baseRed700: "#E59189",
  baseRed800: "#EEB5B1",
  baseRed900: "#F2C8C4",
  baseYellow50: "#241400",
  baseYellow100: "#4d2d00",
  baseYellow200: "#5a3e16",
  baseYellow300: "#70460D",
  baseYellow400: "#8E5910",
  baseYellow500: "#bd7b00",
  baseYellow600: "#D49B4C",
  baseYellow700: "#f6c785",
  baseYellow800: "#ffdfb1",
  baseYellow900: "#ffedd6",
  interactivePrimaryDefault: "#078fe4",
  interactivePrimaryActive: "#078fe4",
  interactivePrimaryHover: "#429ed7",
  interactivePrimaryPressed: "#53A8DD",
  interactivePrimaryDisabled: "#055485",
  interactiveSuccessDefault: "#00a35f",
  interactiveSuccessHover: "#1AA168",
  interactiveSuccessPressed: "#33B981",
  interactiveSuccessActive: "#33B981",
  interactiveSuccessDisabled: "#005330",
  interactiveWarningDefault: "#bd7b00",
  interactiveWarningHover: "#D49B4C",
  interactiveWarningPressed: "#f6c785",
  interactiveWarningDisabled: "#70460D",
  interactiveCriticalDefault: "#dc4e41",
  interactiveCriticalHover: "#da5145",
  interactiveCriticalPressed: "#E59189",
  interactiveCriticalDisabled: "#882D25",
  interactiveInfoDefault: "#078fe4",
  interactiveInfoHover: "#3597d4",
  interactiveInfoPressed: "#53A8DD",
  interactiveInfoDisabled: "#055485",
  interactiveNeutralDefault: "#2E2F33",
  interactiveNeutralHover: "#36353b",
  interactiveNeutralPressed: "#414045",
  interactiveNeutralDisabled: "#504f54",
  backgroundViewDarker: "#38393d",
  backgroundViewHoverBackground: "#01263c",
  backgroundViewLighter: "#0E0E0F",
  backgroundViewLight: "#2b2b2e",
  backgroundViewApp: "#1B1C1E",
  backgroundViewHover: "#2E2F33",
  backgroundViewNavi: "#36353b",
  backgroundSystemInfoLight: "#012032",
  backgroundSystemInfoDefault: "#013a5b",
  backgroundSystemCritcal: "#4d0600",
  backgroundSystemWarning: "#4d2d00",
  backgroundSystemSuccess: "#003d24",
  backgroundPrivateDefault: "#2d2c23",
  backgroundPrivateLight: "#25241d",
  backgroundPrivateDark: "#343228",
  backgroundGradientBrand: "linear-gradient(270deg, #078FE4 0%, #163EA2 100%)",
  backgroundGradientNeutral: "linear-gradient(180deg, #222326 0%, #1d1d20 100%)",
  backgroundGradientLead: "linear-gradient(45deg, #174298 0%, #7148bd 50%, #af7ee6 100%)",
  backgroundGradientScale: "linear-gradient(45deg, #117cba 0%, #31bd95 50%, #9be398 100%)",
  backgroundGradientLaunch: "linear-gradient(45deg, #215ab7 0%, #1999e3 50%, #7cccfa 100%)",
  backgroundGradientPurple: "linear-gradient(-90deg, #C177D5 30%, #653EAC 70%)",
  backgroundGradientOrange: "linear-gradient(90deg, #C45A03 27.46%, #EEAF0C 100%)",
  backgroundGradientRed: "linear-gradient(90deg, #F9062B 27.46%, #FFDBD4 100%)",
  backgroundGradientLightBlue: "linear-gradient(45deg, #0789D9 0%, #62C2F9 100%)",
  backgroundGradientVideo: "linear-gradient(70.48deg, rgba(23,66,152,0.6) 3.87%, rgba(113,72,189,0.6) 53.52%, rgba(175,126,230,0.6) 94.89%)",
  backgroundGradientVideoOverlay: "linear-gradient(45deg, rgba(#174298, 0.7) 0%, rgba(#7148bd, 0.7) 52%, rgba(#af7ee6, 0.7) 100%)",
  backgroundGradientFindTimeGray: "repeating-linear-gradient(135deg, #303236, #303236 6px, #484A51 6px, #484A51 12px)",
  backgroundGradientFindTimeBlue: "repeating-linear-gradient(135deg, #012F49, #012F49 6px, #06456C 6px, #06456C 12px)",
  backgroundGradientFindTimeViolet: "repeating-linear-gradient(135deg, #6c75c2, #6c75c2 6px, #616ab6 6px, #616ab6 12px)",
  backgroundGradientMask: "linear-gradient(-60deg, #e8198a 30%, #e8198a5, #e8198a 70%) right/300% 100%",
  backgroundGradientRainbow: "linear-gradient(90deg, rgb(90, 55, 154) 0%, rgb(184, 99, 207) 7%, rgb(20, 121, 179) 14%, rgb(73, 184, 248) 21%, rgb(85, 199, 82) 27%, rgb(39, 150, 118) 33.33%, rgb(104, 205, 101) 36%, rgb(98, 194, 249) 42%, rgb(22, 136, 202) 47%, rgb(193, 119, 213) 53%, rgb(101, 62, 172) 60%, rgb(22, 136, 202) 66.66%, rgb(98, 194, 249) 100%)",
  backgroundGradientGrayToTransparent: "linear-gradient(to bottom, rgba(29, 30, 32, 1) 0%, rgba(29, 30, 32, 0) 100%)",
  backgroundGradientTellentDefault: "linear-gradient(90deg, #681D74 0%, #230AC0 100%)",
  backgroundGradientTellentPink: "linear-gradient(90deg, #752D81 0%, #FF0096 100%)",
  borderNeutralDefault: "#414045",
  borderNeutralDark: "#504f54",
  borderNeutralDisabled: "#36353b",
  borderNeutralTransparent: "rgba(255,255,255,0.3)",
  borderSystemInfo: "#078fe4",
  borderSystemSuccess: "#00a35f",
  borderSystemCritical: "#dc4e41",
  borderSystemWarning: "#bd7b00",
  borderMainPrimary: "#078fe4",
  borderMainActive: "#055485",
  textSystemInfo: "#3597d4",
  textSystemSuccess: "#1AA168",
  textSystemWarning: "#D49B4C",
  textSystemCritical: "#da5145",
  textMainDefault: "#fff",
  textMainSubdued: "#c9cbcf",
  textMainDisabled: "#57585c",
  textMainActive: "#429ed7",
  iconSystemInfo: "#078fe4",
  iconSystemSuccess: "#00a35f",
  iconSystemWarning: "#bd7b00",
  iconSystemCritical: "#dc4e41",
  iconMainBrand: "#078fe4",
  iconMainDefault: "#fff",
  iconMainSubdued: "#c9cbcf",
  iconMainDisabled: "#57585c",
  iconMainActive: "#3597d4",
  miscSpecialPersonal: "#B26D00",
  miscSpecialViolet: "#6473C6",
  miscSpecialOrange: "#EA6A00",
  miscSpecialOrangeLight: "#1D1A18",
  miscSpecialYellow: "#D19804",
  miscSpecialIndigo: "#0A2463",
  miscSpecialDarkYellow: "#444336",
  miscSpecialDarkBlue: "#0C285E",
  miscSpecialLime: "#709F00",
  miscSpecialGrayDark: "#4B5767",
  miscSpecialGrayLight: "#35363B",
  miscSpecialTurquoise: "#009199",
  miscSpecialTurquoiseLight: "#003A3D",
  miscSpecialPurple: "#863EDA",
  miscSpecialPurpleLight: "#3C156B",
  miscSpecialBrown: "#805C4C",
  miscSpecialBrownLight: "#402E26",
  miscSocialFacebook: "#41599c",
  miscSocialTwitter: "#3dacf0",
  miscSocialGooglePlus: "#d34836",
  miscSocialLinkedin: "#2b80b5",
  miscSocialX: "#000000",
  pricingScaleDefault: "#219475",
  pricingScaleHover: "#239E7D",
  pricingScaleSubdued: "#0D3A31",
  pricingLeadDefault: "#835EC7",
  pricingLeadHover: "#8D6BCC",
  pricingLeadSubdued: "#23153d",
  pricingOptimizeDefault: "#835EC7",
  pricingOptimizeHover: "#8D6BCC",
  pricingOptimizeSubdued: "#23153d",
  pricingGrowDefault: "#219475",
  pricingGrowHover: "#239E7D",
  pricingGrowSubdued: "#0D3A31",
  pricingStartDefault: "#ffffff",
  pricingStartHover: "#dfe0e2",
  white: "#ffffff",
  black: "#121317",
  colorBgDefault: "#222326",
  colorBgHover: "#2E2F33",
  colorBgActive: "#013a5b",
  colorBgDisabled: "#414045",
  colorBgSelected: "#013a5b",
  colorBgPrimaryDefault: "#078fe4",
  colorBgPrimaryHover: "#429ed7",
  colorBgPrimaryPressed: "#53A8DD",
  colorBgPrimarySelected: "#078fe4",
  colorBgPrimaryDisabled: "#055485",
  colorBgPrimarySubduedDefault: "#01263c",
  colorBgPrimarySubduedHover: "#01263c",
  colorBgPrimarySubduedSelected: "#01263c",
  colorBgPrimarySubduedActive: "#01263c",
  colorBgPrimaryStrongDefault: "#429ed7",
  colorBgPrimaryLowDefault: "#013a5b",
  colorBgPrimaryLowHover: "#013a5b",
  colorBgPrimaryLowPressed: "#074d78",
  colorBgNeutralDefault: "#1B1C1E",
  colorBgNeutralHover: "#36353b",
  colorBgNeutralPressed: "#414045",
  colorBgNeutralDisabled: "#504f54",
  colorBgNeutralSelected: "#2E2F33",
  colorBgNeutralLowDefault: "#2b2b2e",
  colorBgNeutralLowHover: "#38393d",
  colorBgNeutralLowDisabled: "#1B1C1E",
  colorBgNeutralStrongDefault: "#414045",
  colorBgNeutralStrongHover: "#504f54",
  colorBgSuccessDefault: "#00a35f",
  colorBgSuccessHover: "#1AA168",
  colorBgSuccessPressed: "#33B981",
  colorBgSuccessDisabled: "#005330",
  colorBgSuccessLowDefault: "#003d24",
  colorBgSuccessLowHover: "#003d24",
  colorBgSuccessLowPressed: "#003d24",
  colorBgCriticalDefault: "#dc4e41",
  colorBgCriticalHover: "#da5145",
  colorBgCriticalPressed: "#E59189",
  colorBgCriticalDisabled: "#882D25",
  colorBgCriticalLowDefault: "#4d0600",
  colorBgCriticalLowHover: "#4d0600",
  colorBgCriticalLowPressed: "#4d0600",
  colorBgCriticalStrongDefault: "#da5145",
  colorBgCriticalStrongActive: "#E59189",
  colorBgCriticalSubduedDefault: "#240200",
  colorBgWarningDefault: "#bd7b00",
  colorBgWarningHover: "#D49B4C",
  colorBgWarningPressed: "#f6c785",
  colorBgWarningDisabled: "#70460D",
  colorBgWarningLowDefault: "#4d2d00",
  colorBgWarningLowHover: "#4d2d00",
  colorBgWarningLowPressed: "#4d2d00",
  colorBgScaleDefault: "#219475",
  colorBgScaleHover: "#239E7D",
  colorBgScaleSubduedDefault: "#0D3A31",
  colorBgLeadDefault: "#835EC7",
  colorBgLeadHover: "#8D6BCC",
  colorBgLeadSubduedDefault: "#23153d",
  colorBgPrivateDefault: "#2d2c23",
  colorBgPrivateHover: "#343228",
  colorBgPrivateStrongDefault: "#343228",
  colorBgPrivateLowDefault: "#25241d",
  colorBgGradientSubdued: "linear-gradient(180deg, #222326 0%, #1d1d20 100%)",
  colorBgSecondaryDefault: "#c9cbcf",
  colorBgSecondaryDisabled: "#38393d",
  colorBgSecondaryStrongDefault: "#fff",
  colorBgSecondaryStrongHover: "#dfe0e2",
  colorBgSecondaryStrongPressed: "#d1d3d6",
  colorBgSecondaryStrongActive: "#f7f8f9",
  colorBgSecondarySubduedDefault: "#313235",
  colorBgSecondaryLowDefault: "#95989d",
  colorBgSecondaryLowDisabled: "#57585c",
  colorBgInfoDefault: "#078fe4",
  colorBgInfoHover: "#3597d4",
  colorBgInfoPressed: "#53A8DD",
  colorBgInfoDisabled: "#055485",
  colorBgInfoStrongDefault: "#3597d4",
  colorBgInfoLowDefault: "#013a5b",
  colorBgInfoLowHover: "#013a5b",
  colorBgInfoLowPressed: "#013a5b",
  colorBgOverdueDefault: "#EA6A00",
  colorBgOverdueLowDefault: "#1D1A18",
  colorBgNoconsentDefault: "#1D1A18",
  colorBgNodataDefault: "#1D1A18",
  colorBgTeamDefault: "#6473C6",
  colorBgPersonalDefault: "#B26D00",
  colorBgOverlayDefault: "rgba(0,0,0,0.8)",
  colorBgOnoverlayHover: "rgba(255,255,255,0.1)",
  colorBgOnoverlayPressed: "rgba(255,255,255,0.2)",
  colorBgGhostHover: "rgba(255,255,255,0.1)",
  colorBgGhostPressed: "rgba(255,255,255,0.2)",
  colorBgTintDefault: "rgba(255,255,255,0.3)",
  colorBgLoadingDefault: "rgba(255,255,255,0.15)",
  colorBgOfferDefault: "#863EDA",
  colorBgOfferHover: "#9454DE",
  colorBgOfferPressed: "#A169E2",
  colorBgOfferLowDefault: "#3C156B",
  colorBgScreeningDefault: "#3597d4",
  colorBgScreeningHover: "#53A8DD",
  colorBgScreeningPressed: "#7ABDE7",
  colorBgScreeningLowDefault: "#013a5b",
  colorBgInterviewDefault: "#078fe4",
  colorBgInterviewHover: "#3597d4",
  colorBgInterviewPressed: "#53A8DD",
  colorBgInterviewLowDefault: "#013a5b",
  colorBgEvaluationDefault: "#009199",
  colorBgEvaluationHover: "#00A9B2",
  colorBgEvaluationPressed: "#00B8C2",
  colorBgEvaluationLowDefault: "#003A3D",
  colorBgHiredDefault: "#00a35f",
  colorBgHiredHover: "#1AA168",
  colorBgHiredPressed: "#33B981",
  colorBgHiredLowDefault: "#003d24",
  colorBgTranslateDefault: "#bd7b00",
  colorBgChartDefault: "rgba(25, 153, 227, 0.1)",
  colorBgVersatileSecondaryStrongDefault: "#45454a",
  colorBgVersatileSecondaryStrongHover: "#313135",
  colorBgVersatileSecondaryStrongPressed: "#484c5b",
  colorBgVersatileSecondaryStrongActive: "#3b3b40",
  colorBgVersatileSecondaryDefault: "#5a5f72",
  colorBgVersatileSecondaryHover: "#484C5B",
  colorBgVersatileSecondaryMediumDefault: "#313135",
  colorBgVersatileSecondaryMediumHover: "#404045",
  colorBgVersatileSecondaryMediumActive: "#62626a",
  colorBgSkeletonDefault: "#303236",
  colorBgOncomponentDefault: "#3E3D42",
  colorBgOncomponentHover: "#3E3D42",
  colorBgOncomponentActive: "#3E3D42",
  colorBgOptimizeDefault: "#835EC7",
  colorBgOptimizeHover: "#8D6BCC",
  colorBgOptimizeSubduedDefault: "#23153d",
  colorBgGrowDefault: "#219475",
  colorBgGrowHover: "#219475",
  colorBgGrowSubduedDefault: "#0D3A31",
  colorBgStartDefault: "#ffffff",
  colorBgStartHover: "#dfe0e2",
  colorBgOnboardingDefault: "#752D81",
  colorBgOnboardingHover: "#752D81",
  colorBgOnboardingLowDefault: "#56215E",
  colorBgOnboardingSubduedDefault: "#3C1C49",
  colorBgTellentDefault: "#E83393",
  colorBgTellentHover: "#EC53A4",
  colorBgTellentPressed: "#EF73B5",
  colorBgTellentActive: "#420027",
  colorBgAppliedDefault: "#4B5767",
  colorBgAppliedHover: "#617085",
  colorBgAppliedPressed: "#7A8A9E",
  colorBgAppliedLowDefault: "#35363B",
  colorBgNotypeDefault: "#805C4C",
  colorBgNotypeHover: "#946A57",
  colorBgNotypePressed: "#A47965",
  colorBgNotypeLowDefault: "#402E26",
  colorBgKiwiDefault: "#00853E",
  colorBgKiwiHover: "#1A402C",
  colorBgJaveloDefault: "#D14905",
  colorBgJaveloHover: "#5F240B",
  colorBgRecruiteeDefault: "#078fe4",
  colorTextDefault: "#c9cbcf",
  colorTextHover: "#fff",
  colorTextPressed: "#fff",
  colorTextDisabled: "#57585c",
  colorTextActive: "#429ed7",
  colorTextStrongDefault: "#fff",
  colorTextStrongHover: "#fff",
  colorTextStrongSelected: "#fff",
  colorTextLowDefault: "#95989d",
  colorTextOnprimaryDefault: "#ffffff",
  colorTextOnprimaryHover: "#ffffff",
  colorTextOnprimaryPressed: "#ffffff",
  colorTextOnprimaryDisabled: "#ffffff",
  colorTextOnprimarySelected: "#ffffff",
  colorTextOnneutralDisabled: "#6d6b70",
  colorTextOnsuccessDefault: "#ffffff",
  colorTextOnsuccessHover: "#ffffff",
  colorTextOnsuccessPressed: "#ffffff",
  colorTextOncriticalDefault: "#ffffff",
  colorTextOncriticalHover: "#ffffff",
  colorTextOncriticalPressed: "#ffffff",
  colorTextOnwarningDefault: "#ffffff",
  colorTextOnwarningHover: "#ffffff",
  colorTextOnwarningPressed: "#ffffff",
  colorTextSuccessDefault: "#00a35f",
  colorTextSuccessHover: "#00a35f",
  colorTextSuccessPressed: "#1AA168",
  colorTextSuccessStrongDefault: "#1AA168",
  colorTextCriticalDefault: "#dc4e41",
  colorTextCriticalHover: "#dc4e41",
  colorTextCriticalPressed: "#da5145",
  colorTextCriticalStrongDefault: "#da5145",
  colorTextInfoDefault: "#078fe4",
  colorTextInfoHover: "#078fe4",
  colorTextInfoPressed: "#3597d4",
  colorTextInfoStrongDefault: "#3597d4",
  colorTextWarningDefault: "#bd7b00",
  colorTextWarningHover: "#bd7b00",
  colorTextWarningPressed: "#D49B4C",
  colorTextWarningStrongDefault: "#D49B4C",
  colorTextOnscaleDefault: "#ffffff",
  colorTextOnscaleHover: "#ffffff",
  colorTextOnleadDefault: "#ffffff",
  colorTextOnleadHover: "#ffffff",
  colorTextScaleDefault: "#219475",
  colorTextScaleHover: "#239E7D",
  colorTextOngradientDefault: "#ffffff",
  colorTextLeadDefault: "#835EC7",
  colorTextOnsecondaryDefault: "#ffffff",
  colorTextOnsecondaryStrongDefault: "#ffffff",
  colorTextOnsecondaryStrongHover: "#ffffff",
  colorTextOnsecondaryStrongPressed: "#ffffff",
  colorTextOninfoStrongDefault: "#ffffff",
  colorTextOninfoDefault: "#ffffff",
  colorTextOninfoHover: "#ffffff",
  colorTextOninfoPressed: "#ffffff",
  colorTextOverdueDefault: "#EA6A00",
  colorTextOnoverdueDefault: "#ffffff",
  colorTextNoconsentDefault: "#EA6A00",
  colorTextNodataDefault: "#EA6A00",
  colorTextOnoverlayDefault: "#ffffff",
  colorTextOnoverlayHover: "#ffffff",
  colorTextOnoverlayPressed: "#ffffff",
  colorTextOnoverlayDisabled: "#95989d",
  colorTextOnoverlayLowDefault: "#36353b",
  colorTextOnghostDefault: "#ffffff",
  colorTextOnghostHover: "#ffffff",
  colorTextOnghostPressed: "#ffffff",
  colorTextOnghostDisabled: "#95989d",
  colorTextPrimaryDefault: "#078fe4",
  colorTextPrimaryActive: "#078fe4",
  colorTextPrimaryHover: "#429ed7",
  colorTextPrimaryPressed: "#429ed7",
  colorTextPrimaryStrongDefault: "#429ed7",
  colorTextPrimaryStrongActive: "#429ed7",
  colorTextOnteamDefault: "#ffffff",
  colorTextOncomponentDefault: "#ffffff",
  colorTextOnoptimizeDefault: "#ffffff",
  colorTextOnoptimizeHover: "#ffffff",
  colorTextOptimizeDefault: "#835EC7",
  colorTextOptimizeHover: "#8D6BCC",
  colorTextOngrowDefault: "#ffffff",
  colorTextOngrowHover: "#ffffff",
  colorTextGrowDefault: "#219475",
  colorTextGrowHover: "#239E7D",
  colorTextOnstartDefault: "#0E0E0F",
  colorTextOnstartHover: "#0E0E0F",
  colorTextOnboardingLowDefault: "#E7D1EB",
  colorTextOnboardingDefault: "#FFFFFF",
  colorTextOnonboardingDefault: "#ffffff",
  colorTextOnonboardingHover: "#ffffff",
  colorTextOntellentDefault: "#ffffff",
  colorTextOntellentHover: "#ffffff",
  colorTextOntellentPressed: "#ffffff",
  colorTextOnappliedDefault: "#ffffff",
  colorTextOnappliedHover: "#ffffff",
  colorTextOnappliedPressed: "#ffffff",
  colorTextOnscreeningDefault: "#ffffff",
  colorTextOnscreeningHover: "#ffffff",
  colorTextOnscreeningPressed: "#ffffff",
  colorTextOninterviewDefault: "#ffffff",
  colorTextOninterviewHover: "#ffffff",
  colorTextOninterviewPressed: "#ffffff",
  colorTextOnevaluationDefault: "#ffffff",
  colorTextOnevaluationHover: "#ffffff",
  colorTextOnevaluationPressed: "#ffffff",
  colorTextOnofferDefault: "#ffffff",
  colorTextOnofferHover: "#ffffff",
  colorTextOnofferPressed: "#ffffff",
  colorTextOnhiredDefault: "#ffffff",
  colorTextOnhiredHover: "#ffffff",
  colorTextOnhiredPressed: "#ffffff",
  colorTextOnnotypeDefault: "#ffffff",
  colorTextOnnotypeHover: "#ffffff",
  colorTextOnnotypePressed: "#ffffff",
  colorTextOnkiwiDefault: "#ffffff",
  colorTextOnjaveloDefault: "#ffffff",
  colorTextOnrecruiteeDefault: "#ffffff",
  colorIconDefault: "#c9cbcf",
  colorIconHover: "#fff",
  colorIconPressed: "#fff",
  colorIconDisabled: "#57585c",
  colorIconActive: "#3597d4",
  colorIconStrongDefault: "#fff",
  colorIconOnprimaryDefault: "#ffffff",
  colorIconOnprimaryHover: "#ffffff",
  colorIconOnprimaryPressed: "#ffffff",
  colorIconOnprimaryDisabled: "#ffffff",
  colorIconOnneutralDisabled: "#6d6b70",
  colorIconOnsuccessDefault: "#ffffff",
  colorIconOnsuccessHover: "#ffffff",
  colorIconOnsuccessPressed: "#ffffff",
  colorIconOnsuccessDisabled: "#ffffff",
  colorIconOncriticalDefault: "#ffffff",
  colorIconOncriticalHover: "#ffffff",
  colorIconOncriticalPressed: "#ffffff",
  colorIconOnwarningDefault: "#ffffff",
  colorIconOnwarningHover: "#ffffff",
  colorIconOnwarningPressed: "#ffffff",
  colorIconSuccessDefault: "#00a35f",
  colorIconSuccessHover: "#00a35f",
  colorIconSuccessPressed: "#1AA168",
  colorIconSuccessActive: "#33B981",
  colorIconSuccessStrongDefault: "#1AA168",
  colorIconCriticalDefault: "#dc4e41",
  colorIconCriticalHover: "#dc4e41",
  colorIconCriticalPressed: "#da5145",
  colorIconCriticalStrongDefault: "#da5145",
  colorIconCriticalStrongHover: "#da5145",
  colorIconInfoDefault: "#078fe4",
  colorIconInfoHover: "#078fe4",
  colorIconInfoPressed: "#3597d4",
  colorIconInfoStrongDefault: "#3597d4",
  colorIconWarningDefault: "#bd7b00",
  colorIconWarningHover: "#bd7b00",
  colorIconWarningPressed: "#D49B4C",
  colorIconWarningStrongDefault: "#D49B4C",
  colorIconScaleDefault: "#219475",
  colorIconScaleHover: "#239E7D",
  colorIconOngradientDefault: "#ffffff",
  colorIconOnscaleDefault: "#ffffff",
  colorIconOnscaleHover: "#ffffff",
  colorIconLeadDefault: "#835EC7",
  colorIconOnleadDefault: "#ffffff",
  colorIconOnleadHover: "#ffffff",
  colorIconOnsecondaryDefault: "#ffffff",
  colorIconOnsecondaryStrongDefault: "#ffffff",
  colorIconOnsecondaryStrongHover: "#ffffff",
  colorIconOninfoStrongDefault: "#ffffff",
  colorIconOninfoDefault: "#ffffff",
  colorIconOninfoHover: "#ffffff",
  colorIconOninfoPressed: "#ffffff",
  colorIconOverdueDefault: "#EA6A00",
  colorIconOnoverdueDefault: "#ffffff",
  colorIconNoconsentDefault: "#EA6A00",
  colorIconNodataDefault: "#EA6A00",
  colorIconOnoverlayDefault: "#ffffff",
  colorIconOnoverlayHover: "#ffffff",
  colorIconOnoverlayPressed: "#ffffff",
  colorIconOnoverlayDisabled: "#95989d",
  colorIconOnghostDefault: "#ffffff",
  colorIconOnghostHover: "#ffffff",
  colorIconOnghostPressed: "#ffffff",
  colorIconOnghostDisabled: "#95989d",
  colorIconPrimaryDefault: "#078fe4",
  colorIconPrimaryHover: "#429ed7",
  colorIconPrimaryPressed: "#078fe4",
  colorIconPrimaryStrongDefault: "#429ed7",
  colorIconPrimaryStrongPressed: "#429ed7",
  colorIconLowDefault: "#95989d",
  colorIconLowDisabled: "#504f54",
  colorIconSubduedDefault: "#313235",
  colorIconOncomponentDefault: "#ffffff",
  colorIconAiDefault: "#8066e5",
  colorIconTranslateDefault: "#bd7b00",
  colorIconOptimizeDefault: "#835EC7",
  colorIconOptimizeHover: "#8D6BCC",
  colorIconOnoptimizeDefault: "#ffffff",
  colorIconOnoptimizeHover: "#ffffff",
  colorIconGrowDefault: "#219475",
  colorIconGrowHover: "#239E7D",
  colorIconOngrowDefault: "#ffffff",
  colorIconOngrowHover: "#ffffff",
  colorIconOnboardingDefault: "#B455C4",
  colorIconOnboardingLowDefault: "#E7D1EB",
  colorIconOnonboardingDefault: "#ffffff",
  colorIconOnonboardingHover: "#ffffff",
  colorIconOnhiredDefault: "#ffffff",
  colorIconOnhiredHover: "#ffffff",
  colorIconOnhiredPressed: "#ffffff",
  colorIconOnkiwiDefault: "#ffffff",
  colorIconOnjaveloDefault: "#ffffff",
  colorIconOnappliedDefault: "#ffffff",
  colorIconOnappliedHover: "#ffffff",
  colorIconOnappliedPressed: "#ffffff",
  colorIconOnscreeningDefault: "#ffffff",
  colorIconOnscreeningHover: "#ffffff",
  colorIconOnscreeningPressed: "#ffffff",
  colorIconOninterviewDefault: "#ffffff",
  colorIconOninterviewHover: "#ffffff",
  colorIconOninterviewPressed: "#ffffff",
  colorIconOnnotypeDefault: "#ffffff",
  colorIconOnnotypeHover: "#ffffff",
  colorIconOnnotypePressed: "#ffffff",
  colorIconOnevaluationDefault: "#ffffff",
  colorIconOnevaluationHover: "#ffffff",
  colorIconOnevaluationPressed: "#ffffff",
  colorIconOnofferDefault: "#ffffff",
  colorIconOnofferHover: "#ffffff",
  colorIconOnofferPressed: "#ffffff",
  colorIconOntellentDefault: "#ffffff",
  colorIconOntellentHover: "#ffffff",
  colorIconOntellentPressed: "#ffffff",
  colorIconTellentDefault: "#E83393",
  colorIconTellentActive: "#E83393",
  colorBorderDefault: "#414045",
  colorBorderHover: "#414045",
  colorBorderPressed: "#414045",
  colorBorderDisabled: "#36353b",
  colorBorderSelected: "#414045",
  colorBorderActive: "#055485",
  colorBorderSuccessDefault: "#00a35f",
  colorBorderSuccessHover: "#00a35f",
  colorBorderSuccessPressed: "#1AA168",
  colorBorderSuccessSubduedDefault: "#004d2d",
  colorBorderSuccessLowDefault: "#006E40",
  colorBorderCriticalDefault: "#dc4e41",
  colorBorderCriticalHover: "#dc4e41",
  colorBorderCriticalPressed: "#da5145",
  colorBorderCriticalLowDefault: "#882D25",
  colorBorderCriticalSubduedDefault: "#65211b",
  colorBorderInfoDefault: "#078fe4",
  colorBorderInfoHover: "#078fe4",
  colorBorderInfoPressed: "#3597d4",
  colorBorderInfoSubduedDefault: "#074d78",
  colorBorderWarningDefault: "#bd7b00",
  colorBorderWarningHover: "#bd7b00",
  colorBorderWarningPressed: "#D49B4C",
  colorBorderWarningDisabled: "#70460D",
  colorBorderWarningSubduedDefault: "#5a3e16",
  colorBorderNeutralHover: "#504f54",
  colorBorderNeutralDisabled: "#1B1C1E",
  colorBorderOncomponentDefault: "#222326",
  colorBorderSecondaryDefault: "#c9cbcf",
  colorBorderSecondaryHover: "#fff",
  colorBorderSecondaryDisabled: "#57585c",
  colorBorderSecondaryLowDefault: "#95989d",
  colorBorderSecondaryLowDisabled: "#494b50",
  colorBorderSecondaryStrongDefault: "#dfe0e2",
  colorBorderPrimaryDefault: "#078fe4",
  colorBorderPrimaryHover: "#429ed7",
  colorBorderPrimaryStrongDefault: "#429ed7",
  colorBorderPrimarySubduedDefault: "#074d78",
  colorBorderPrimaryLowDefault: "#06649F",
  colorBorderTranslateDefault: "#bd7b00",
  colorBorderOnghostDefault: "#ffffff",
  colorBorderOnghostHover: "#ffffff",
  colorBorderOnghostPressed: "#ffffff",
  colorBorderOnghostDisabled: "#95989d",
  colorBorderPrivateDefault: "#444336",
  colorBorderStrongDefault: "#504f54",
  colorBorderStrongDisabled: "#504f54",
  colorBorderLowDefault: "#36353b",
  colorBorderLowHover: "#313235",
  colorBorderTeamDefault: "#6473C6",
  colorBorderVersatileSecondaryDefault: "#57565d",
  colorBorderTintDefault: "rgba(255,255,255,0.3)",
  colorGradientPrimary: "linear-gradient(270deg, #078FE4 0%, #163EA2 100%)",
  colorGradientLaunch: "linear-gradient(45deg, #215ab7 0%, #1999e3 50%, #7cccfa 100%)",
  colorGradientScale: "linear-gradient(45deg, #117cba 0%, #31bd95 50%, #9be398 100%)",
  colorGradientLead: "linear-gradient(45deg, #174298 0%, #7148bd 50%, #af7ee6 100%)",
  colorGradientPurple: "linear-gradient(-90deg, #C177D5 30%, #653EAC 70%)",
  colorGradientOrange: "linear-gradient(90deg, #C45A03 27.46%, #EEAF0C 100%)",
  colorGradientRed: "linear-gradient(90deg, #F9062B 27.46%, #FFDBD4 100%)",
  colorGradientLightBlue: "linear-gradient(45deg, #0789D9 0%, #62C2F9 100%)",
  colorGradientVideo: "linear-gradient(70.48deg, rgba(23,66,152,0.6) 3.87%, rgba(113,72,189,0.6) 53.52%, rgba(175,126,230,0.6) 94.89%)",
  colorGradientVideoOverlay: "linear-gradient(45deg, rgba(#174298, 0.7) 0%, rgba(#7148bd, 0.7) 52%, rgba(#af7ee6, 0.7) 100%)",
  colorGradientFindTimeNeutral: "repeating-linear-gradient(135deg, #303236, #303236 6px, #484A51 6px, #484A51 12px)",
  colorGradientFindTimePrimary: "repeating-linear-gradient(135deg, #012F49, #012F49 6px, #06456C 6px, #06456C 12px)",
  colorGradientFindTimeViolet: "repeating-linear-gradient(135deg, #6c75c2, #6c75c2 6px, #616ab6 6px, #616ab6 12px)",
  colorGradientTruncate: "#e8198a00",
  colorGradientShimmer: "linear-gradient(-60deg, #e8198a 30%, #e8198a5, #e8198a 70%) right/300% 100%",
  colorGradientRainbow: "linear-gradient(90deg, rgb(90, 55, 154) 0%, rgb(184, 99, 207) 7%, rgb(20, 121, 179) 14%, rgb(73, 184, 248) 21%, rgb(85, 199, 82) 27%, rgb(39, 150, 118) 33.33%, rgb(104, 205, 101) 36%, rgb(98, 194, 249) 42%, rgb(22, 136, 202) 47%, rgb(193, 119, 213) 53%, rgb(101, 62, 172) 60%, rgb(22, 136, 202) 66.66%, rgb(98, 194, 249) 100%)",
  colorGradientNeutralToTransparent: "linear-gradient(to bottom, rgba(29, 30, 32, 1) 0%, rgba(29, 30, 32, 0) 100%)",
  colorGradientTellent: "linear-gradient(90deg, #681D74 0%, #230AC0 100%)",
  colorTooltipFeature: "#0C285E",
  colorTooltipFeatureLight: "#0988DE",
  colorAvatarSteelLighter: "#38393d",
  colorAvatarSteelLight: "#313235",
  colorAvatarSteelDark: "#61636b",
  colorAvatarGrayLight: "#414045",
  colorAvatarGrayDark: "#838288",
  colorAvatarGreen: "#239E7D",
  colorAvatarBlueLight: "#078fe4",
  colorAvatarBlueDark: "#3597d4",
  colorAvatarBlueDarker: "#7ABDE7",
  colorAvatarPink: "#9A4CB6",
  colorAvatarPurple: "#8D6BCC",
  colorAvatarYellow: "#bd7b00",
  colorAvatarOrange: "#EA6A00",
  colorAvatarSkeleton: "#2E2F33",
  colorChartPrimaryDefault: "#0789D9",
  colorChartBlueDefault: "#8DCDF2",
  colorChartTurquoiseDefault: "#34A6B2",
  colorChartPurpleDefault: "#653EAC",
  colorChartPurpleSubduedDefault: "#9554DE",
  colorChartGrayDefault: "#678198",
  colorChartGreenDefault: "#68CD65",
  colorChartGreenSubduedDefault: "#92E78D",
  colorChartGraySubduedDefault: "#859AAD",
  colorChartYellowDefault: "#DAA10B",
  colorChartYellowSubduedDefault: "#DCC105",
  colorChartGrayStrongDefault: "#425261",
  colorSeparatorTransparent: "rgba(0,0,0,0.2)",
  colorLogoTypography: "#ffffff",
  colorCandidatesBgPrimaryDefault: "#0789D9",
  colorCandidatesBgGreenStrongDefault: "#1a8e68",
  colorCandidatesBgOrangeDefault: "#c45a03",
  colorCandidatesBgYellowDefault: "#f2b10d",
  colorCandidatesBgGreenSubduedDefault: "#2caa86",
  colorCandidatesBgBlueDefault: "#0C6090",
  colorCandidatesBgVioletDefault: "#512FA2",
  colorCandidatesBgGreenDefault: "#46af0e",
  colorCandidatesBgBlueStrongDefault: "#083F5E",
  colorCandidatesBgPurpleDefault: "#8c44a7",
  colorCandidatesBorderPrimaryDefault: "#1999E3",
  colorCandidatesBorderGreenStrongDefault: "#1a8e68",
  colorCandidatesBorderOrangeDefault: "#c45a03",
  colorCandidatesBorderYellowDefault: "#f2b10d",
  colorCandidatesBorderGreenSubduedDefault: "#2caa86",
  colorCandidatesBorderBlueDefault: "#0C6090",
  colorCandidatesBorderVioletDefault: "#512FA2",
  colorCandidatesBorderGreenDefault: "#46af0e",
  colorCandidatesBorderBlueStrongDefault: "#083F5E",
  colorCandidatesBorderPurpleDefault: "#8c44a7",
  colorScrollbarThumbDefault: "#5A5A5A",
  colorScrollbarThumbHover: "#737373",
  colorScrollbarTrackDefault: "#2E2F30",
  colorMarketplaceLogo: "#FFFFFF",
  colorMarketplaceRibbon: "#005330",
  colorVersatileDefault: "#ffffff",
  avatarSteelLighter: "#38393d",
  avatarSteelLight: "#313235",
  avatarSteelDark: "#61636b",
  avatarGrayLight: "#414045",
  avatarGrayDark: "#838288",
  avatarGreen: "#239E7D",
  avatarBlueLight: "#078fe4",
  avatarBlueDark: "#3597d4",
  avatarBlueDarker: "#7ABDE7",
  avatarPink: "#9A4CB6",
  avatarPurple: "#8D6BCC",
  avatarYellow: "#bd7b00",
  avatarOrange: "#EA6A00",
  avatarSkeleton: "#2E2F33",
  chartBrandDefault: "#0789D9",
  chartSkyDefault: "#8DCDF2",
  chartOceanDefault: "#34A6B2",
  chartOrchidDefault: "#653EAC",
  chartLavenderDefault: "#9554DE",
  chartSteelDefault: "#678198",
  chartEmeraldDefault: "#68CD65",
  chartMintDefault: "#92E78D",
  chartSmokeDefault: "#859AAD",
  chartSunflowerDefault: "#DAA10B",
  chartLemonDefault: "#DCC105",
  chartGraphiteDefault: "#425261",
  candidatesBgBrandDefault: "#0789D9",
  candidatesBgRainforestDefault: "#1a8e68",
  candidatesBgFireDefault: "#c45a03",
  candidatesBgGoldDefault: "#f2b10d",
  candidatesBgJungleDefault: "#2caa86",
  candidatesBgNavyDefault: "#0C6090",
  candidatesBgEggplantDefault: "#512FA2",
  candidatesBgGrassDefault: "#46af0e",
  candidatesBgDenimDefault: "#083F5E",
  candidatesBgLilacDefault: "#8c44a7",
  candidatesBorderBrandDefault: "#1999E3",
  candidatesBorderRainforestDefault: "#1a8e68",
  candidatesBorderFireDefault: "#c45a03",
  candidatesBorderGoldDefault: "#f2b10d",
  candidatesBorderJungleDefault: "#2caa86",
  candidatesBorderNavyDefault: "#0C6090",
  candidatesBorderEggplantDefault: "#512FA2",
  candidatesBorderGrassDefault: "#46af0e",
  candidatesBorderDenimDefault: "#083F5E",
  candidatesBorderLilacDefault: "#8c44a7",
  aiDefault: "#927ce9",
  productRecruitee50: "#01263c",
  productRecruitee100: "#013a5b",
  productRecruitee200: "#074d78",
  productRecruitee300: "#055485",
  productRecruitee400: "#06649F",
  productRecruitee500: "#078fe4",
  productRecruitee600: "#429ed7",
  productRecruitee700: "#53A8DD",
  productRecruitee800: "#7ABDE7",
  productRecruitee900: "#8DC8ED",
  productKiwi50: "#0F2115",
  productKiwi100: "#1A402C",
  productKiwi200: "#1E422B",
  productKiwi300: "#2E6240",
  productKiwi400: "#3D8356",
  productKiwi500: "#00853E",
  productKiwi600: "#6FB688",
  productKiwi700: "#92C8A5",
  productKiwi800: "#B6D9C2",
  productKiwi900: "#C7E2D0",
  productJavelo50: "#2A0F01",
  productJavelo100: "#5F240B",
  productJavelo200: "#541D02",
  productJavelo300: "#7D2C03",
  productJavelo400: "#A73A04",
  productJavelo500: "#D14905",
  productJavelo600: "#DA6931",
  productJavelo700: "#E38A5D",
  productJavelo800: "#ECAA89",
  productJavelo900: "#F0BA9F",
  productTellent50: "#260016",
  productTellent100: "#420027",
  productTellent200: "#5E0B37",
  productTellent300: "#951B5C",
  productTellent400: "#CC287F",
  productTellent500: "#E83393",
  productTellent600: "#EC53A4",
  productTellent700: "#EF73B5",
  productTellent800: "#F6B3D7",
  productTellent900: "#FCE3F0",
  onboardingBackgroundDefault: "#752D81",
  onboardingBackgroundLow: "#56215E",
  onboardingBackgroundSubdued: "#3C1C49",
  onboardingTextDefault: "#FFFFFF",
  onboardingTextLow: "#E7D1EB",
  onboardingIconDefault: "#B455C4",
  onboardingIconLow: "#E7D1EB",
};
